require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/pages/checkout.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/pages/checkout.legacy.js
// module id = 666
// module chunks = 31